import { combineHash } from '@eureka/utils/url';
import { NAV_MENU_TYPE } from '../types';
import { resolveEurekaLink } from '@eureka/utils/resolve-link';
import '@patsnap-ui/icon/assets/solid/aim.svg';
import '@patsnap-ui/icon/assets/solid/SearchLeft.svg';
import '@patsnap-ui/icon/assets/menu/agent.svg';
import '@patsnap-ui/icon/assets/menu/community.svg';
import '@patsnap-ui/icon/assets/menu/customize.svg';
import '@patsnap-ui/icon/assets/menu/kg.svg';
import '@patsnap-ui/icon/assets/menu/newTask.svg';
import '@patsnap-ui/icon/assets/menu/vault.svg';

export const MENU_LIST_CONFIG = [
    // 跳转到大首页去
    {
        type: NAV_MENU_TYPE.NEW_TASKS,
        icon: 'MenuNewTask',
        link: resolveEurekaLink('home'),
        module: NAV_MENU_TYPE.NEW_TASKS,
    },
    /**
     * 只有登录用户才能看到
     */
    {
        type: NAV_MENU_TYPE.SEARCH_TASKS,
        icon: 'SolidSearchLeft',
        module: NAV_MENU_TYPE.SEARCH_TASKS,
    },
    {
        type: NAV_MENU_TYPE.AGENT_LIST,
        icon: 'MenuAgent',
        link: resolveEurekaLink('agent-list'),
        module: NAV_MENU_TYPE.AGENT_LIST,
    },
    {
        type: NAV_MENU_TYPE.CUSTOMIZE_LIST,
        icon: 'MenuCustomize',
        link: resolveEurekaLink('customize-list'),
        module: NAV_MENU_TYPE.CUSTOMIZE_LIST,
    },
    {
        type: NAV_MENU_TYPE.CUSTOM_AGENT,
        icon: 'SolidInsightsTechnology',
        link: combineHash('/ls', '/explore'),
        router: '/explore',
        module: NAV_MENU_TYPE.CUSTOM_AGENT,
        authKey: 'custom_table_permission',
    },
    {
        type: NAV_MENU_TYPE.AI_STUDIO,
        icon: 'SolidChartTopipc',
        link: '/ai-studio',
        router: '/agents',
        module: NAV_MENU_TYPE.AI_STUDIO,
        authKey: 'ai_agent_studio',
    },
    // {
    //     type: NAV_MENU_TYPE.VAULT,
    //     icon: vaultIcon,
    //     link: '/vault',
    //     module: NAV_MENU_TYPE.VAULT,
    //     authKey: 'vault_permission',
    // },
    {
        type: NAV_MENU_TYPE.MONITOR,
        icon: 'SolidAim',
        link: resolveEurekaLink('monitor'),
        module: NAV_MENU_TYPE.MONITOR,
    },
    {
        type: NAV_MENU_TYPE.WORK_PROJECT,
        icon: 'MenuKg',
        link: combineHash('/ls', '/graph'),
        router: '/graph',
        module: NAV_MENU_TYPE.WORK_PROJECT,
        authKey: 'work_project',
    },
    {
        type: NAV_MENU_TYPE.COMMUNITY,
        icon: 'MenuCommunity',
        link: resolveEurekaLink('rd-gallery'),
        module: NAV_MENU_TYPE.COMMUNITY,
    }
];

export const INCOGNITO_MENU_ITEM = {
    type: NAV_MENU_TYPE.INCOGNITO,
    icon: 'SolidSecutiry',
}

export const EVENTS_CONFIG = {
    [NAV_MENU_TYPE.HOME]: 'SS Seek Search',
    [NAV_MENU_TYPE.AI_STUDIO]: 'SS AI Studio',
    [NAV_MENU_TYPE.AI_GENERATE]: 'SS AI Agent',
    [NAV_MENU_TYPE.MONITOR_TOPIC]: 'SS News Letter',
    [NAV_MENU_TYPE.MONITOR_SUBSCRIPTION]: 'SS News Letter',
    [NAV_MENU_TYPE.INCOGNITO]: 'SS Seek Search',
    [NAV_MENU_TYPE.WORK_PROJECT]: 'SS Work Project',
    [NAV_MENU_TYPE.SEEK_SEARCH]: 'SS Seek Search',
    [NAV_MENU_TYPE.TECH_MIND]: 'SS Idea AI',
    [NAV_MENU_TYPE.TECH_FMEA]: 'SS Tech FMEA',
    [NAV_MENU_TYPE.TECH_RESEARCH]: 'SS Project',
    [NAV_MENU_TYPE.IDEA_EXPLORATION]: 'SS Idea AI',
    [NAV_MENU_TYPE.MATERIAL_MIND]: 'SS Material Mind',
    [NAV_MENU_TYPE.PATENT_DISCLOSURE]: 'SS Patent Disclosure',
    [NAV_MENU_TYPE.SEARCH_TASKS]: 'SS Seek Search',
};

export const SAVED_OPENED_KEY = 'COMMON_NAV_COLLAPSE';

export const ROUTE_NAME_WHITELIST = ['chatDetail'];
